import { AlertIcon } from '#assets/ReactSvg.ts';
import { ConfirmDialog } from '#components/patterns/confirmations/confirm-dialog/ConfirmDialog.tsx';

type Props = {
  onCancel: () => void;
  onAccept: () => void;
};

/**
 * {@link DisableManagedLighthousesWarning} warns the user before they opt a network out of managed
 * lighthouses. Mirrors {@link DeleteLighthouseWarning}.
 */
export function DisableManagedLighthousesWarning({ onCancel, onAccept }: Props) {
  return (
    <ConfirmDialog
      isOpen={true}
      onCancel={onCancel}
      onAccept={onAccept}
      acceptButtonText="Continue"
      title={
        <div className="flex align-center">
          <AlertIcon className="mr-4" />
          Disable managed lighthouses
        </div>
      }
    >
      <p className="p">
        Managed lighthouses keep this network’s hosts connected without you running your own. If you disable them,
        you’ll need to add and maintain your own lighthouse before hosts can form new connections.
      </p>
    </ConfirmDialog>
  );
}
